export default __webpack_public_path__ + "static/media/sigma-icon.f85836fc.webp";